<mat-card>
  <mat-toolbar-row>
    <h3>{{ 'Storage' | translate }}</h3>
    <div class="actions action-icon">
      <button
        *ixRequiresRoles="requiredRoles"
        mat-button
        [ixTest]="['storage', 'configure']"
        (click)="onConfigurePressed()"
      >
        {{ 'Configure' | translate }}
      </button>
    </div>
  </mat-toolbar-row>

  <mat-card-content>
    <mat-list>
      <mat-list-item>
        <span class="label">{{ 'System Dataset Pool' | translate }}:</span>
        <span *ixWithLoadingState="systemDatasetPool$ as systemDatasetPool" class="value">
          {{ systemDatasetPool }}
        </span>
      </mat-list-item>
      <mat-list-item>
        <span class="label">{{ 'Swap Size' | translate }}:</span>
        <span *ixWithLoadingState="swapSize$ as swapSize" class="value">
          {{ swapSize ? swapSize + ' GiB' : '-' }}
        </span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
